import {CpcProductFiltersEndpointsApiService} from "@/main";
import {
    CnkCodesResponseRestDto,
    ProductFilterOverviewRestDto,
    ProductFilterRestDto
} from "@/api/pharma-cpc-mgmt/models";

export default {
    state() {
        return {
            product_filter_cnk_list: {} as CnkCodesResponseRestDto,
            product_filter_complex: {} as ProductFilterRestDto,
            product_filter_overview: [] as ProductFilterOverviewRestDto[],
        };
    },
    actions: {
        async searchCnkListProductFilter(context: any, filter_code: string) {
            const response = await CpcProductFiltersEndpointsApiService.findCnkCodesOfProductFilter(filter_code);

            context.commit('setCnkListProductFilter', {
                body: response.data,
                filter_code: filter_code,
            });
        },
        async searchProductFilterOverview(context: any, payload: any) {
            const is_named = payload?.is_named ?? undefined as boolean | undefined;
            const is_precalculated = payload?.is_precalculated ?? undefined as boolean | undefined;

            const response = await CpcProductFiltersEndpointsApiService.findProductFilters(undefined, is_named, is_precalculated);

            context.commit('setProductFilterOverview', response.data.results);
        },
        async saveCnkListProductFilter(_context: any, payload: any) {
            await CpcProductFiltersEndpointsApiService.syncProductFilter(payload.body, payload.filter_code);
        },
    },
    mutations: {
        setCnkListProductFilter(state: any, payload: any) {
            state.product_filter_cnk_list = payload.body;
        },
        setProductFilterOverview(state: any, payload: ProductFilterOverviewRestDto[]) {
            state.product_filter_overview = payload;
        },
    },
    getters: {
        getCnkListProductFilter(state: any): CnkCodesResponseRestDto {
            return state.product_filter_cnk_list;
        },
        getProductFilterOverview(state: any): ProductFilterOverviewRestDto[] {
            return state.product_filter_overview;
        },
    },
}
